import { useMutation } from '@apollo/client';

import { StaffCreateTransactionInput } from '../../apollo/__generated__/graphql';
import { STAFF_CREATE_TRANSACTION } from '../graphql/mutations/staffCreateTransactionMutation.graphql';

export const useStaffCreateTransactionMutation = () => {
  const [mutate] = useMutation(STAFF_CREATE_TRANSACTION);

  const createTransaction = (
    createTransactionInput: StaffCreateTransactionInput,
  ) => {
    mutate({
      variables: {
        createTransactionInput,
        eventId: createTransactionInput.eventId,
      },
    });
  };

  return { createTransaction };
};
